<template>
  <div class="w-full">
    <div class="widget text-neutral-content">
      <div class="font-bold text-2xl mb-4">
        <slot name="header">
          <h2>Default Header</h2>
        </slot>
      </div>
      <div class="">
        <slot name="body">
          <h2>Default Body</h2>
        </slot>
      </div>
      <div class="mt-8 flex gap-6 justify-end">
        <slot name="footer">
          <h2>Default Footer</h2>
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped></style>
